import React from "react";
import { useNavigate } from "react-router-dom";
import CustomButton from "../components/CustomButton";
import { FiExternalLink, FiAlertTriangle } from "react-icons/fi";
import { TbBulb } from "react-icons/tb";

const LearningHub = () => {
  const navigate = useNavigate();
  const ToolCard = ({
    icon,
    title,
    description,
    buttonText,
    buttonType = "external",
    onClick = () => {},
  }) => {
    return (
      <div className="card p-3 h-100">
        <div className="d-flex justify-content-between align-items-start">
          <div
            className={`rounded p-2 `}
            style={{
              color: "#0BA7FF",
              backgroundColor: "#CEEDFF",
              width: "fit-content",
            }}
          >
            {icon}
          </div>
        </div>
        <h6 className="mt-3 ">{title}</h6>
        <div className="text-muted p4 mb-3">{description}</div>

        <CustomButton
          onClick={onClick}
          variant="outline"
          className={`btn-sm px-3 py-2 w-100 justify-between`}
        >
          <span className="flex-grow-1 text-start">{buttonText}</span>
          <FiExternalLink size={18} />
        </CustomButton>
      </div>
    );
  };
  return (
    <div className="container-fluid p-4" style={{ backgroundColor: "#F9FAFC" }}>
      <div className="container">
        <header className="mb-4">
          <h4 className="fw-bold">Learning Hub</h4>
          <p className="text-muted p4 ">
            Explore valueble project insights, including common risks and
            importatnt lesson learned. The Learning Hub helps your team identify
            potential challenges, reflect on past experiences , and apply proven
            strategies to imptove future project outcomes.
          </p>
        </header>
        <div className="row g-3">
          <div className="col-md-6">
            <ToolCard
              icon={<FiAlertTriangle size={25} />}
              title="Risks"
              description={
                <div>
                  <p>
                    Risks are potential issues that may affect project success —
                    like unclear requirements or limited resources. Identifying
                    them early helps teams plan ahead and reduce disruptions.
                  </p>
                  <p className="fw-bold mb-2">Use the Risk Page to</p>
                  <ul className="mb-0">
                    <li>
                      View common project risks across different projects.
                    </li>
                    <li>Add new risks for ongoing projects.</li>
                    <li>
                      Record the date and the specific context in which the risk
                      was initially identified.
                    </li>
                    <li>Monitor and reflect on recurring issues over time.</li>
                  </ul>
                </div>
              }
              buttonText="Open Risks"
              onClick={() => navigate("/risk")}
            />
          </div>
          <div className="col-md-6">
            <ToolCard
              icon={<TbBulb size={25} />}
              title="Lessons"
              description={
                <div>
                  <p>
                    Lessons are takeaways from a project that show what worked
                    and what didn’t. They help teams avoid mistakes, repeat
                    successes, and improve future project outcomes.
                  </p>
                  <p className="fw-bold mb-2">Use the Lessons Page to</p>
                  <ul className="mb-0">
                    <li>Browse lessons learned from past projects.</li>
                    <li>Log new lessons that can benefit others.</li>
                    <li>Categorize lessons by project and user.</li>
                    <li>Support improvement and knowledge-sharing.</li>
                    <li>Build a culture of reflection and learning.</li>
                  </ul>
                </div>
              }
              buttonText="Open Lessons"
              onClick={() => navigate("/lesson")}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningHub;
